import './defaultChartValues.css';
export var defaultChartSize = '_1rtjj3o0-3-15-1';